import { useMemo } from 'react'
import styled, { css } from 'styled-components'

import Icon from '@/components/common/Icon'
import Text from '@/components/common/Text'
import BaseLink from '@/components/common/BaseLink'
import { useTranslations } from 'next-intl'

const TYPE_PAYED = 'payed'

const ItemCss = css`
  display: flex;
  align-items: center;
  height: 44px;
  padding: 10px;

  &:hover {
    color: var(--yellow);
    background-color: #f0f0f0;
  }

  &:active,
  &:focus {
    background-color: #e6e6e6;
  }

  &:hover ${Text} {
    color: var(--yellow);
  }

  &:active ${Text}, &:focus ${Text} {
    color: var(--black);
  }

  &:hover ${Icon} {
    background-color: var(--yellow);
  }

  &:active ${Icon}, &:focus ${Icon} {
    background-color: var(--black);
  }
`

const Item = styled(BaseLink)`
  ${ItemCss};
`

const ItemButton = styled.div`
  ${ItemCss};
  cursor: pointer;
`

const Access = styled.div`
  padding: 4px 8px;
  color: var(--${(props) => (props.type === TYPE_PAYED ? 'green' : 'red')});
  background-color: var(
    --${(props) => (props.type === TYPE_PAYED ? 'green-light' : 'red-lignt')}
  );
  border-radius: 3px;

  font-weight: 500;
  font-size: 12px;
`

const HeaderUserMenuItem = ({
  icon,
  link,
  text,
  withAccess,
  subscriptionType,
  needChangePath,
  type = 'link',
  ...props
}) => {
  const access = useMemo(() => {
    return subscriptionType === TYPE_PAYED ? 'Premium-access' : 'Demo-acess'
  }, [subscriptionType])
  const t = useTranslations('common')

  const Component = type === 'link' ? Item : ItemButton

  return (
    <Component href={link} {...props} isChangePath={needChangePath}>
      <Icon className="mr-2" color="grey" icon={icon} size="18" />
      <Text size="14">{t(`${text}`)}</Text>
      {withAccess && (
        <Access className="ml-auto" type={subscriptionType}>
          {access}
        </Access>
      )}
    </Component>
  )
}

export default HeaderUserMenuItem
